import React from 'react';

import accounting from '~/misc/accounting';

import css from './index.css';

import ToolTip from '~/components/common/ToolTip';
import config from '~/config';

// <span>To be successful at negotiation you need to know market RPM for a lane,
//  amount of loads at a destination, road tolls, fuel prices and consumption for load weight</span>


const Price = (props) => {
  const value = props.value;

  if (!config.priceDescription2) {
    if (props.hidePrice) {
      return <span className={css.lockMoney} />;
    }
    return <span >{accounting.formatMoney(value) || '—'}</span>;
  }

  return (
    <span className={css.wrap}>
      <ToolTip
        right={true}
        trigger={props.hidePrice ? <span className={css.lockMoney} /> : <span className={css.value}>
          { accounting.formatMoney(value) || '—' }
        </span>}
      >
        <span>Price presence depends on broker</span> <br/><br/>
        <span>To book a load you need to call a broker and negotiate about price</span> <br/><br/>
      </ToolTip>
    </span>
  );
};

export default Price;



// WEBPACK FOOTER //
// ./src/components/common/Price/index.js